import {observer} from 'mobx-react';
import {dateSpan} from 'shared/tools';
import {Table} from 'main/components';
import _ from 'lodash';
import {FormattedMessage} from 'react-intl';

const visibleColumns = (fieldUpdates) => {
  const cols = new Set();

  fieldUpdates.forEach(fieldUpdate => {
    Object.entries(fieldUpdate).forEach(([hourType, hours]) => {
      if (hours !== null) cols.add(hourType);
    });
  });

  return cols;
};

const columns = (fieldUpdates) => {
  const visible = visibleColumns(fieldUpdates);
  const cols = [{
    header: 'nmbr.updates.directory.Effective Period',
    width: 3,
    render: model => dateSpan(model.startDate, model.endDate)
  }];

  if (visible.has('regular')) {
    cols.push({
      header: 'nmbr.updates.directory.Regular',
      width: 2,
      attribute: 'regular'
    });
  }
  if (visible.has('overtime')) {
    cols.push({
      header: 'nmbr.updates.directory.Overtime',
      width: 1.5,
      attribute: 'overtime'
    });
  }
  if (visible.has('doubleOvertime')) {
    cols.push({
      header: 'nmbr.updates.directory.Double Overtime',
      width: 1.5,
      attribute: 'doubleOvertime'
    });
  }
  if (visible.has('holidays')) {
    cols.push({
      header: 'nmbr.updates.directory.Holiday',
      width: 2,
      attribute: 'holidays'
    });
  }
  Object.keys(_.first(fieldUpdates).timeOff).forEach(leaveType => {
    cols.push({
      header: `nmbr.updates.directory.leave_types.${_.snakeCase(leaveType)}`,
      width: 2,
      render: model => _.get(model, ['timeOff', leaveType])
    });
  });

  const unusedWidth = 12 - _.sumBy(cols, 'width');
  if (unusedWidth > 0) _.last(cols).width += unusedWidth;

  return cols;
};

const SyncedHoursTable = observer(({nmbrUpdate}) => {
  if (!nmbrUpdate.hasFieldUpdate('synced_hours')) return null;

  const fieldUpdates = nmbrUpdate.fieldUpdatesForType('synced_hours');

  return (
    <div className='space-y'>
      <div className='h4 medium'><FormattedMessage id='nmbr.updates.directory.Hours Worked'/></div>
      <Table
        columns={columns(fieldUpdates)}
        models={fieldUpdates}
        showLinks={false}
      />
    </div>
  );
});

export default SyncedHoursTable;
